import axios, { AxiosResponse } from "axios";

const url = "/services/isnaportal/open-api/creditor-requirement/get-all";
const taxOrgUrl = "/services/isnaportal/open-api/tax-org/get-all";
const printUrl = "/services/isnaportal/open-api/creditor-requirement/generate/pdf";
const downloadUrl = "/services/isnaportal/open-api/creditor-requirement/generate";
// ?clientRecaptchaResponse=${token}
export const getRegistorCreditorsInfo = (request: any, token?: any): Promise<AxiosResponse> => {
  return axios.post(`${url}`, request);
};

export const printRegistorCreditorsInfo = (request: any, token?: any): Promise<AxiosResponse> => {
  return axios.post(`${printUrl}`, request, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  });
};

export const getTaxOrg = () => {
  return axios.get(`${taxOrgUrl}`);
};

export const loadRegionData = async (): Promise<AxiosResponse> => {
  return axios.request({
    method: "GET",
    url: `/services/isnaportal/open-api/tax-org/search`,
    params: {
      levels: "1,2",
    },
  });
};

export const downloadFile = (id: number) => {
  return axios({
    url: `/services/isnaportal/open-api/creditor-requirement-file/get-by-id/${id}`,
    method: "GET",
    responseType: "blob",
  });
};

export const downloadInfo = (request: any, token?: any): Promise<AxiosResponse> => {
  return axios.post(`${downloadUrl}`, request, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  });
};
